// Styles for PointsDetails

import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledPointsDetails = styled.div`
  .points-potential-description {
   * Handles rich text content with proper spacing and indentation
   */
  .points-potentional-description {
    /* First paragraph spacing - primary benefits */
    p {
      &:first-child {
        /* Mobile spacing - compact for smaller screens */
        margin-bottom: ${toRem(32)};

        /* Desktop spacing - generous for better readability */
        @media ${baseVariables.mediaQuery.lg} {
          margin-bottom: ${toRem(56)};
        }
      }
    }

    /* Unordered list styling with responsive indentation */
    ul {
      /* Mobile indent - conservative space usage */
      padding-left: ${toRem(24)};

      /* Desktop indent - better visual hierarchy */
      @media ${baseVariables.mediaQuery.lg} {
        padding-left: ${toRem(40)};
      }
    }
  }
`;
